import dayjs from "../../../util/dayjs";

/* ⚠ `YYYY`, not moment's `yyyy`: dayjs has no lowercase year token and passes an unknown one
   through literally, so the moment-era format string rendered "14.08.yyyy 09:05" verbatim. */
const fmtDate = v => (v ? dayjs(v).format("DD.MM.YYYY HH:mm") : "—");

export default {
  slug: "surveys",
  endpoint: "surveys/",
  titleKey: "surveys_title",
  subtitleKey: "surveys_sub",
  columns: [
    { field: "title", label: "f_title", sort: "title" },
    { label: "f_active_from", format: row => fmtDate(row.active_from) },
    { label: "f_active_to", format: row => fmtDate(row.active_to) },
  ],
  fields: [
    { name: "title", type: "text", label: "f_title", required: true },
    { name: "description", type: "textarea", label: "f_description", wide: true },
    { name: "active_from", type: "datetime", label: "f_active_from", required: true },
    { name: "active_to", type: "datetime", label: "f_active_to", required: true },
    {
      name: "form_organization_mode",
      type: "select",
      label: "f_form_organization_mode",
      options: [
        { value: "products", label: "Products" },
        { value: "brands", label: "Brands" },
        { value: "categories", label: "Categories" },
        { value: "subcategories", label: "Subcategories" },
      ],
    },
    { name: "audience", type: "audience", label: "f_audience", wide: true },
    { name: "questions", type: "questions", label: "f_questions", wide: true },
  ],
  sections: [
    { title: "sec_basic", fields: ["title", "description"] },
    { title: "sec_schedule", fields: ["active_from", "active_to", "form_organization_mode"] },
    { title: "sec_audience", fields: ["audience"] },
    { title: "sec_questions", fields: ["questions"] },
  ],
  softDelete: true,
};
